<div class="list-group"><ng-content></ng-content></div>